<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="color"
    :timeout="timer"
    text
    top
    content-class="text-center"
  >
    <v-icon left>{{ icon }}</v-icon>{{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        :color="color"
        text
        icon
        v-bind="attrs"
        @click="showSnackbar = false"
      >
        <v-icon>mdi-close-thick</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  data: () => ({
    showSnackbar: false,
    message: 'Data are still invalid!',
    color: '#ff4c51 !important',
    icon: 'mdi-wrong',
    timer: 3000
  }),
  methods: {
    show(data) {
      let color = '#ff4c51 !important'
      if (data) {
        this.message = data.message || 'Data are still invalid!'
        if (data.color === 'success') {
          color = '#56ca00 !important'
        } else if (data.color === 'error') {
          color = '#ff4c51 !important'
        }
        this.timer = data.timer || 3000
        this.icon = data.icon || 'mdi-wrong'
      }
      this.color = color
      this.showSnackbar = true
    }
  },
}
</script>